import { useEffect } from "react"

import { Divider, Flex, Modal, Typography } from "antd"
import { useDispatch, useSelector } from "react-redux"

import Private from "../../../../../Components/Private"
import Icon from "../../../../../Icon"
import { formatCurrency } from "../../../../../Utils/utils"
import { getOutsiderPayoutMethod, outsiderWithdraw } from "../../../redux/referrals.thunks"

import "./WithdrawFundsModal.less"

const { Text } = Typography

const WithdrawFundsModal = ({ open, close }) => {
  const dispatch = useDispatch()
  const {
    outsiderPayoutMethod,
    outsiderPayoutMethodFetching,
    outsiderBlocks,
    outsiderBlocksFetching,
    outsiderWithdrawFetching
  } = useSelector((state) => state.referrals)

  const withdrawFunds = () => {
    dispatch(outsiderWithdraw({ amount_cents: outsiderBlocks?.available_funds_cents }))
      .unwrap()
      .then(close)
      // The thunk already raised the global error notification.
      .catch(() => {})
  }

  useEffect(() => {
    if (open) {
      dispatch(getOutsiderPayoutMethod())
    }
  }, [open])

  return (
    <Modal
      open={open}
      onClose={close}
      onCancel={close}
      onOk={withdrawFunds}
      okButtonProps={{
        loading: outsiderWithdrawFetching
      }}
      title={
        <Flex vertical gap={12}>
          <Text className="title">Withdraw funds</Text>
          <Text type="secondary" strong>
            Please confirm the withdrawal details below.
          </Text>
        </Flex>
      }
      closeIcon={<Icon type="cross_small" />}
      cancelText="Cancel withdrawal"
      okText="Confirm & withdraw"
      className="withdraw-funds-modal clear-bg"
      classNames={{
        content: "clear-bg"
      }}
      width={442}
      loading={outsiderPayoutMethodFetching || outsiderBlocksFetching}
      destroyOnClose
    >
      <Flex vertical gap={24}>
        <div className="grid-2cols">
          <Text strong type="secondary">
            Payout method
          </Text>
          <Text strong className="text-end">
            Direct deposit{" "}
            <Text type="secondary" strong>
              (USD bank account)
            </Text>
          </Text>
          <Text strong type="secondary">
            {outsiderPayoutMethod?.country === "US" ? "Bank account number" : "IBAN"}
          </Text>
          <Text strong className="text-end">
            <Private>{outsiderPayoutMethod?.masked_identifier ?? "-"}</Private>
          </Text>
        </div>
        <div>
          <div className="grid-2cols">
            <Text type="secondary" strong>
              Total commissions
            </Text>
            <Text strong className="text-end">
              <Private>{formatCurrency(outsiderBlocks?.available_funds_cents / 100 ?? 0)}</Private>
            </Text>
          </div>
          <Divider className="divider" />
          <div className="grid-2cols">
            <Text type="secondary" strong>
              Total
            </Text>
            <Text strong className="text-end">
              <Private>{formatCurrency(outsiderBlocks?.available_funds_cents / 100 ?? 0)}</Private>
            </Text>
          </div>
        </div>

        <div className="note-warning">
          <Text type="warning" strong>
            Please note:
          </Text>
          <ul className="note-warning_list">
            <li>
              <Text type="warning" strong>
                Funds may take 2-5 business days to appear in your bank account.
              </Text>
            </li>
            <li>
              <Text type="warning" strong>
                The final amount you receive may vary due to fluctuating foreign exchange rates at
                the time of withdrawal.
              </Text>
            </li>
          </ul>
        </div>
      </Flex>
    </Modal>
  )
}

export default WithdrawFundsModal
